import React, { Fragment, useEffect, useState } from 'react';
import { Row, Col, Form, Button, Card, Modal, Table, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Auth, LoadingComponent } from 'recupero-comunes';
import { serviceGetRequisitos, serviceGetDocumentos, serviceGetDocumento, serviceDeleteDocumento} from '../../../api/api-aprobacion-objecion';
import { CarpetaDigitalComponent } from 'reccol-caso-general'
import { FaSearch, FaTrash } from "react-icons/fa";
import Mensajes from '../../mensajes'

const Documentos = ({ llaves, cfg_form, showModalDocumentos, setShowModalDocumentos }) => {
    const [loading, setLoading] = useState(false);
    const { rutUsuario } = Auth.currentUser()
    const [requisitos, setRequisitos] = useState([]);
    const [documentos, setDocumentos] = useState([]);
    const [requisitoSeleccted, setRequisitoSeleccted] = useState([]);
    const [documentoEliminar, setDocumentoEliminar] = useState([]);
    const [showCarpeta, setShowCarpeta] = useState(false)
    const handleShowCarpeta = () => setShowCarpeta(true)
    const handleCloseCarpeta = () => setShowCarpeta(false)    
    const [showToast, setShowToast] = useState(true);
    const [usuarioEliminaDocumento, setUsuarioEliminaDocumento] = useState(false);
    
    const handleCloseToast = () => {
        setShowToast(false);
        getDocumentos(requisitoSeleccted.idDocto);
    }
    const [respuestaServices, setRespuestaServices] = useState(false)

    const [showModalConfirm, setShowModalConfirm] = useState(false);
    
    useEffect(() => {
        if (showModalDocumentos) initialValues();
    }, [showModalDocumentos])

    const initialValues = () => {
        getRequisitos();
        Auth.currentUser().roles.forEach(value => { if (value.rol === "70ELIDOCCAR") setUsuarioEliminaDocumento(true); })
    }
    const getRequisitos = async () => {
        let query = Buffer.from(JSON.stringify({"idCaso":llaves && llaves['idCaso'], "gestion":"CC"})).toString('base64');
        setLoading(true);
        const response = await serviceGetRequisitos(query);
        setLoading(false);

        setRequisitos(response);
    }
    const handleDocumentos = async (selected, pos) => {
        setRequisitoSeleccted(selected);
        getDocumentos(selected.idDocto);
    }
    const getDocumentos = async (idDocumento) => {
        let query = Buffer.from(JSON.stringify({"idCaso":llaves && llaves['idCaso'], "idDocumento": idDocumento})).toString('base64');
        setLoading(true);
        const response = await serviceGetDocumentos(query);
        setLoading(false);
        setDocumentos(response);
    }
    const handleVerDocumento = async (folioCarga) => {
        if (folioCarga) {
            setLoading(true);
            let query = Buffer.from(JSON.stringify({
                idCaso: llaves?.idCaso,
                idImplicadoCaso: 0,
                idCompania: llaves?.idOrgCaso,
                idfolioCarga: folioCarga
            })).toString('base64')

            try {
                const response = await serviceGetDocumento(query);
                setLoading(false);

                var link = document.createElement("a");
                link.download = response.filename;
                link.href = "data:" + response.mimetype + ";base64," + response.file;
                link.click();
            } catch (error) {
                //console.log("error: ", error)
                setRespuestaServices({code:-1, message: error.message});
                setShowToast(true);
                setLoading(false);
            }
        }
    }
    const handleEliminarDocumento = (documento) => {
        setDocumentoEliminar(documento);
        setShowModalConfirm(true);
    }
    const eliminarDocumento = async () => {
        setShowModalConfirm(false);
        if (documentoEliminar) {
            setLoading(true);
            let query = {
                idCaso: llaves?.idCaso,
                idImplicadoCaso: 0,
                idCompania: llaves?.idOrgCaso,
                documento: documentoEliminar,
                idUsuario: rutUsuario
            }
            try {
                const response = await serviceDeleteDocumento(query);
                setRespuestaServices(response);
                setShowToast(true);
                setLoading(false);

            } catch (error) {
                //console.log("error: ", error)
                setRespuestaServices({code:-1, message: error.message});
                setShowToast(true);
                setLoading(false);
            }
        }
    }

    return (
        <Fragment>
            <Modal show={showCarpeta} onHide={handleCloseCarpeta} size="xl">              
                <CarpetaDigitalComponent 
                    handleClose={handleCloseCarpeta} 
                    idCaso={llaves && llaves['idCaso']}
                    idImplicado={llaves && llaves['idImplicado']}
                    idOrganizacionCaso={llaves && llaves['idOrgCaso']}
                    prototipo={2}            
                />         
            </Modal>
            <LoadingComponent show={loading} />

            <Modal show={showModalDocumentos} onHide={setShowModalDocumentos} size='xl'>
                <Card>
                    <Card.Header className='mt-0 mb-0' as='h6' style={{ backgroundColor: '#4F517A', color: 'white' }}>
                        {cfg_form && cfg_form.cfg_form9["respuestarecobro-modaldoctos-title"]}
                    </Card.Header>
                    <Card.Body className="customCard">
                        <Row>
                            <Col md='4'>
                                <Table striped className="customTable">
                                    <thead>
                                        <tr>
                                            <th></th>
                                            <th>Requisitos</th>
                                            <th>Ver Detalle</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {requisitos.map((requisito, index) => (
                                            <tr key={index}>
                                                <td>
                                                    <Form.Check type="checkbox" checked={requisito.folioCarga} disabled name="group1" id={`check-${index}`} />
                                                </td>
                                                <td>{requisito.nombre}</td>                                        
                                                <td>
                                                    <Form.Check type="radio" disabled={!requisito.folioCarga} name="group1" id={`radio-${index}`} onChange={() => handleDocumentos(requisito, index)} />
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                                {requisitos.length === 0 &&
                                    <span style={{ display: 'inherit', textAlign: 'center' }}>No hay requisitos.</span>
                                }
                            </Col>
                            <Col>
                                <Table striped className="customTable">
                                        <thead>
                                            <tr>
                                                <th>Documento</th>
                                                <th>Fecha Carga</th>
                                                <th>Usr. Ingreso</th>
                                                <th>Tamaño (KB)</th>
                                                <th>Acciones</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {documentos.map((documento, index) => (
                                                <tr key={index}>
                                                    <td>{requisitoSeleccted.nombre}</td> 
                                                    <td>{documento.fechaCargaFormato}</td> 
                                                    <td>{documento.usuarioCarga}</td>
                                                    <td>{documento.tamanio}</td>
                                                    <td>
                                                        <OverlayTrigger overlay={<Tooltip id='tooltip-disabled'>Ver Documento</Tooltip>}>
                                                            <Button className='' variant='info'>
                                                                <FaSearch
                                                                    size={20}
                                                                    color='white'
                                                                    onClick={() => handleVerDocumento(documento.folioCarga)}
                                                                />
                                                            </Button>
                                                        </OverlayTrigger>
                                                        &nbsp;&nbsp;
                                                        <OverlayTrigger overlay={<Tooltip id='tooltip-disabled'>Eliminar Documento</Tooltip>}>
                                                            <Button className='' variant='info' disabled={!documento.archivoEliminable || !usuarioEliminaDocumento}>
                                                                <FaTrash
                                                                    size={20}
                                                                    color='white'
                                                                    onClick={() => handleEliminarDocumento(documento)}
                                                                />
                                                            </Button>
                                                        </OverlayTrigger>
                                                    </td>
                                                </tr>
                                        ))}
                                    </tbody>
                                </Table>
                                {documentos.length === 0 &&
                                    <span style={{ display: 'inherit', textAlign: 'center' }}>No hay Documentos.</span>
                                }
                            </Col>
                        </Row>
                        <Row>
                            <Col md="8"></Col>
                            <Col >                                                    
                                {respuestaServices && 
                                    <Mensajes
                                        showToast={showToast}
                                        handleCloseToast={handleCloseToast}
                                        delay={4000}
                                        responseData={respuestaServices}
                                    ></Mensajes>
                                }
                            </Col>
                        </Row>
                    </Card.Body>
                    <Card.Footer style={{ display: 'flex', justifyContent: 'right', gap: '8px' }}>
                        <Button className='m-2 ' variant='carpeta' onClick={handleShowCarpeta}>
                            {cfg_form && cfg_form.cfg_form9["respuestarecobro-modaldoctos-btn-carpeta"]}
                        </Button>
                        <Button className='m-2' variant='outline-info' onClick={() => setShowModalDocumentos(false)}>
                            {cfg_form && cfg_form.cfg_form9["respuestarecobro-modaldoctos-btn-volver"]}
                        </Button>
                    </Card.Footer>
                </Card>
            </Modal>
            <Modal show={showModalConfirm} onHide={() => setShowModalConfirm(false)} size='md'>
                <Card>
                    <Card.Header className='mt-0 mb-0' as='h6' style={{ backgroundColor: '#e8761a', color: 'white' }}>
                        Confirmación
                    </Card.Header>

                    <Card.Body>
                        ¿Confirma eliminación de documento.?
                    </Card.Body>

                    <Card.Footer style={{ display: 'flex', justifyContent: 'center' }}>
                        <Button className='m-2 w-auto' variant='outline-info' onClick={() => setShowModalConfirm(false)}>No</Button>
                        <Button className='m-2 w-auto' variant='danger' onClick={() => eliminarDocumento()}>Si</Button>
                    </Card.Footer>
                </Card>
            </Modal>
                
            <style type='text/css'>
                {`
                .is_required:after {
                    content: "*";
                    margin-left: 2px;
                    color: #000;
                    font-weight: 500;
                    font-size: 12pt;
                }
                .btn-carpeta {
                    background-color: #D59B49;
                    color: #FFFFFF;
                    width: 140px;
                    
                }
                .btn-carpeta:hover{
                    background-color:#e1b97f;
                    color: #FFFFFF;            
                }
                .customTable > thead {
                    color: white; 
                    background-color: rgb(114, 139, 176);
                }
                .customTable > thead > tr > th {
                    padding: 20px 0;
                }
            `}
            </style>
        </Fragment>
    )


}
export default Documentos;